var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna2N49EAosihid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6827 15.5031C6.5402 15.5031 6.3977 15.4506 6.2852 15.3381C6.0677 15.1206 6.0677 14.7606 6.2852 14.5431L11.1752 9.65313C11.5352 9.29313 11.5352 8.70813 11.1752 8.34813L6.2852 3.45813C6.0677 3.24063 6.0677 2.88062 6.2852 2.66313C6.5027 2.44563 6.86269 2.44563 7.08019 2.66313L11.9702 7.55312C12.3527 7.93562 12.5702 8.45313 12.5702 9.00063C12.5702 9.54813 12.3602 10.0656 11.9702 10.4481L7.08019 15.3381C6.96769 15.4431 6.8252 15.5031 6.6827 15.5031Z",
    fill: "#868484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna2N49EAosihid);
export default __webpack_public_path__ + "static/media/mna2n49e-aosihid.da55f3fa025fd38df1f14e035ed8916e.svg";
export { ForwardRef as ReactComponent };